import Container from "react-bootstrap/Container";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import Button from "@mui/material/Button";
import CreateIcon from "@mui/icons-material/Create";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import VendorsModal from "./VendorsModal";
import VendorsDeleteModal from "./VendorsDeleteModal";
import VendorsEditModal from "./VendorsEditModal";
import VendorsViewModal from "./VendorsViewModal";
import { errorToast } from "../../common/ToastMessage";
import Loader from "../../common/Loader";

function Vendors() {
  const navigate = useNavigate();
  const [vendor, setVendor] = useState();
  const [open, setOpen] = useState(false);
  const [openmodel, setOpenModel] = useState(false);
  const [vendoresid, setVendoresId] = useState();
  const [openeditmodal, setOpenEditModal] = useState(false);
  const [viewvendordata, setViewVendorsData] = useState("");
  const [openviewmodal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [vendorsdata, setVendorsData] = useState("");
  const [isActive, setLoaderActive] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getvendor();
  }, []);

  const getvendor = async (id) => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    setLoaderActive(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor`,
        {
          headers: headers,
          params: {
            InventoryIssueManagementID: id,
          },
        }
      );
      setLoaderActive(false)
      if (response.status === 400) {
        navigate("/login");
      }
      const tempdata = response.data.data;
      const vendorData = tempdata?.map((item, index) => {
        return { ...item, no: index + 1 };
      });
      setVendor(vendorData);
    } catch (error) {
      setLoaderActive(false)
      console.log(error);
    }
  };

  const openModal = () => {
    setOpen(true);
  };
  const closeModel = () => {
    setOpen(false);
  };

  const openDeleteModal = (vendorDeletId) => {
    setVendoresId(vendorDeletId);
    setOpenModel(true);
  };
  const closeDeleteModal = (id) => {
    setVendoresId(id);
    setOpenModel(false);
  };

  const openEditModal = (vendoresId) => {
    setVendoresId(vendoresId);
    setOpenEditModal(true);

    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };

    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor/GetByID`,

        {
          headers: headers,
          params: {
            id: vendoresId,
          },
        }
      )
      .then(function (response) {
        setVendorsData(response?.data?.data[0]);
        if (response?.status == "200") {
          setLoaderActive(false);
        }
      })
      .catch(function (error) {
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  };

  const closeEditModal = () => {
    setOpenEditModal(false);
    setLoaderActive(false);
  };

  const openViewModal = async (id) => {
    setVendoresId(id);
    setLoaderActive(true);
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };

    await axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Vendor/GetByID`,
        {
          headers: headers,
          params: {
            id: id,
          },
        }
      )
      .then(function (response) {
        setViewVendorsData(response?.data?.data[0]);

        if (response?.status == "200") {
          setLoaderActive(false);
        }
      })
      .catch(function (error) {
        console.log("error", error);
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
    setOpenViewModal(true);
  };

  //close view modal
  const closeViewModal = () => {
    setOpenViewModal(false);
  };

  // Material Table Columns
  const columns = [
    { title: "No.", field: "no" },
    { title: "Vendor Name", field: "supplierName" },
    { title: "Vendor Number", field: "supplierNumber" },
    { title: "Vendor Type", field: "supplierType" },
    { title: "Vendor Address", field: "supplierAddress" },
    {
      title: "Action",
      field: "action",

      render: (rowData) => (
        <span>
          <Link
            href="#"
            className="edit me-3"
            title="View"
            onClick={() => openViewModal(rowData.supplierId)}
            variant="success"
          >
            <VisibilityIcon color="primary" />
          </Link>
          <Link
            href="#"
            className="edit me-3 "
            title="Edit"
            onClick={() => openEditModal(rowData.supplierId)}
          >
            <CreateIcon color="success" />
          </Link>
        </span>
      ),
    },
  ];

  const defaultMaterialTheme = createTheme();
  return (
    <>
      <Loader isLoading={isActive} />
      <div className="management">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="">
                <ThemeProvider theme={defaultMaterialTheme}>
                  <div className="aad-btn-wrap">
                    <Button variant="contained" onClick={openModal}>
                      Add New Vendor
                    </Button>
                  </div>
                  <MaterialTable
                    title="Vendors"
                    options={{
                      selection: true,
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          selectedRow === rowData?.tableData?.id
                            ? "#F3F5F5"
                            : "#FFF",
                      }),
                      headerStyle: {
                        backgroundColor: "#E5F0FB",
                      },
                    }}
                    onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow?.tableData?.id)}
                    actions={[
                      {
                        tooltip: "Remove All Selected Users",
                        icon: "delete",
                        onClick: (evt, data) => {
                          let selectedVendor = [];
                          data?.map((dat) => selectedVendor.push(dat.supplierId));
                          openDeleteModal(selectedVendor);
                        },
                      },
                    ]}
                    columns={columns}
                    data={vendor}
                  />
                </ThemeProvider>
              </div>
            </Container>
            <VendorsModal open={open} close={closeModel} getvendor={getvendor} setLoaderActive={setLoaderActive} />
            <VendorsDeleteModal
              vendoresId={vendoresid}
              open={openmodel}
              close={closeDeleteModal}
              getvendor={getvendor}
              setLoaderActive={setLoaderActive}
            />

            <VendorsEditModal
              vendoresId={vendoresid}
              vendorsdata={vendorsdata}
              open={openeditmodal}
              close={closeEditModal}
              getvendor={getvendor}
              setLoaderActive={setLoaderActive}
            />
            <VendorsViewModal
              vendoresId={vendoresid}
              viewvendordata={viewvendordata}
              open={openviewmodal}
              close={closeViewModal}
            />
          </main>
        </div>
      </div>
    </>
  );
}

export default Vendors;
